import { useTranslation } from "_metronic/i18n/language";
import { Box } from "app/pages/admin/components";
import AudioPlayer from "app/pages/admin/components/AudioPlayer";
import Image from "app/pages/admin/components/Image";
import { NoarLocaliseApiService } from "app/services/NoarLocaliseApiService";
import { FC, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

interface RenderMidiaProps {
  mediaUri: string;
}

type FileType = "image" | "media" | "unknown";

const RenderMidia: FC<RenderMidiaProps> = ({ mediaUri }) => {
  const translate = useTranslation();
  const api = new NoarLocaliseApiService();

  const [loading, setLoading] = useState(true);
  const [tempUri, setTempUri] = useState<string>("");

  const getFileType = (url: string): FileType => {
    if (!url) return "unknown";

    const path = url.split("?")[0];
    const extension = path
      .split(".")
      .pop()
      ?.toLowerCase();

    if (!extension) return "unknown";

    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
    const mediaExtensions = ["mp4", "mp3", "wav", "avi", "mov", "wmv"];

    if (imageExtensions.includes(extension)) return "image";
    if (mediaExtensions.includes(extension)) return "media";

    return "unknown";
  };

  const fileType = getFileType(mediaUri);

  const generateDate = (daysAhead = 15): string => {
    const date = new Date();
    date.setDate(date.getDate() + daysAhead);
    return date.toISOString().split("T")[0];
  };

  const fetchTempUri = async () => {
    setLoading(true);
    try {
      const expiryDate = generateDate();

      const reqBase = {
        method: "GET",
        url: `/azure-blob/generate-temp-uri`,
      };

      const response = await api.makeHttpRequest({
        ...reqBase,
        params: { filePath: mediaUri, expirationTime: expiryDate },
      });
      setTempUri(response.uri);
    } catch (error) {
      console.error("Failed to fetch temp URI:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTempUri();
  }, [mediaUri, tempUri, api.generateTempUri]);

  if (loading) {
    return (
      <Box>
        <Spinner
          style={{
            borderWidth: "4px",
            color: "#fd7e14",
          }}
        />
      </Box>
    );
  }

  if (fileType === "image" && tempUri) {
    return <Image src={tempUri} />;
  }

  if (fileType === "media" && tempUri) {
    return <AudioPlayer audioUrl={tempUri} />;
  }

  return <></>;
};

export default RenderMidia;
